// /utils/auth.js
import { signIn, signOut } from 'next-auth/react'
import { toast } from 'react-toastify'

export async function loginWithCredentials({
  account,
  password,
  rememberMe = false,
  onSuccess,
  onError,
  setCartProducts,
}) {
  const res = await signIn('credentials', {
    redirect: false,
    account,
    password,
    rememberMe,
    deviceInfo:
      typeof navigator !== 'undefined' ? navigator.userAgent : 'web',
  })

  if (res?.ok) {
    toast.success('登入成功')
    onSuccess?.()
    return
  }

  const message =
    !res?.error || res.error === 'CredentialsSignin'
      ? '帳號或密碼錯誤'
      : res.error

  toast.error(message)
  onError?.(message, res)
}

export async function logout({ setCartProducts, onSuccess } = {}) {
  await signOut({ redirect: false })
  toast.success('已登出')
  if (typeof window !== 'undefined') localStorage.removeItem('cartList')
  setCartProducts?.([])
  onSuccess?.()
}
